
let cryptoUtils = {
    hashCode: require('../../modules/helpers/crypto-utils').hashCode,
    randomStringFast: require('../../modules/helpers/crypto-utils').randomStringFast,
};
let is = require('../../modules/helpers/is');

let defaultDeliveryOptions = {
    workingSaturday: true,
    workingSunday: true,
    freeDays: [],
    selectedCity: {},
};

let defaultSelectedCity = {};

function CalendarHelper(deliveryOptions, selectedCity = {}) {
    this.objectId = cryptoUtils.randomStringFast(10);
    this.deliveryOptions = deliveryOptions || defaultDeliveryOptions;
    this.selectedCity = selectedCity || defaultSelectedCity;

    let todayZero = new Date();
    todayZero.setUTCHours(0, 0, 0, 0);
    this.todayZero = todayZero;

    this.computeFreeDays();
}

CalendarHelper.prototype.freeDaysHash = function () {
    return cryptoUtils.hashCode(JSON.stringify(this.deliveryOptions.freeDays));
}

/**
 * This will compute freeDays from deliveryOptions.freeDays
 */
CalendarHelper.prototype.computeFreeDays = function () {
    const freeDaysHash = this.freeDaysHash();
    if (this.deliveryOptions.freeDaysHash === freeDaysHash) {
        // console.log('computeFreeDays exit same hash', freeDaysHash);
        return;
    }
    this.deliveryOptions.freeDaysHash = freeDaysHash;
    // console.log('computeFreeDays new hash', freeDaysHash);

    let freeDays = [];
    let testTime;
    let self = this;
    this.deliveryOptions.freeDays.forEach(freeDay => {
        // console.log('computeFreeDays day', freeDay);
        if (freeDay.match(/^\d{4}-\d{2}-\d{2}$/)) {
            let [year, month, day] = freeDay.split('-').map(Number);
            if (year === 0) {
                let testDate = new Date();
                testDate.setUTCHours(0, 0, 0, 0);
                year = testDate.getFullYear();
                let startYear = year - 1;
                let endYear = year + 1;
                while (startYear <= endYear) {
                    if (month === 0) {
                        while (month < 12) {
                            testDate.setUTCFullYear(startYear, month, day);
                            testTime = testDate.getTime();
                            freeDays.push(testTime);
                            month++;
                        }
                        month = 0; // reset month for next year
                    } else {
                        testDate.setUTCFullYear(startYear, month - 1, day);
                        testTime = testDate.getTime();
                        freeDays.push(testTime);
                    }
                    startYear++;
                }
            } else {
                testTime = self.dateStringToDate(freeDay).getTime();
                freeDays.push(testTime);
            }
        } else if (freeDay.match(/^\d{4}-\d{2}-\d{2}:\d{4}-\d{2}-\d{2}$/)) {
            let [startDay, endDay] = freeDay.split(':');
            let startTime = self.dateStringToDate(startDay).getTime();
            let endTime = self.dateStringToDate(endDay).getTime();
            while (startTime <= endTime) {
                freeDays.push(startTime);
                startTime += 24 * 60 * 60 * 1000;
            }
        } else if (freeDay.match(/^\d{4}-\d{2}-\d{2}|\d{4}-\d{2}-\d{2}$/)) {
            freeDays.push(...freeDay.split('|').map(c => self.dateStringToDate(c).getTime()));
        }
    });
    // console.log('computed freeDays', freeDays);
    this.freeDays = freeDays;
}

CalendarHelper.prototype.update = function (deliveryOptions, selectedCity) {
    if (!is.nue(selectedCity)) {
        this.selectedCity = selectedCity;
    }
    if (!is.nue(deliveryOptions)) {
        this.deliveryOptions = deliveryOptions;
        this.computeFreeDays(); // compute free days only when needed
    }
}

CalendarHelper.prototype.isDateAvailable = function (dateString, deliveryOptions, selectedCity) {
    let date = this.dateStringToDate(dateString);
    this.update(deliveryOptions, selectedCity);

    let _dateIsToday = date.getTime() === this.todayZero.getTime();
    let _dateIsInWeekend = this.dateIsInWeekend(date);
    let _dateIsInFreeDays = this.dateIsInFreeDays(date);

    if (_dateIsToday && !this.selectedCity.hasSameDayDelivery) {
        return false;
    }

    if (_dateIsInFreeDays) {
        return false;
    }

    return true;
}

CalendarHelper.prototype.computeDeliveryIntervals = function (deliveryIntervals, deliveryDate = new Date()) {
    let now = new Date();

    let nowZero = new Date();
    nowZero.setUTCHours(0, 0, 0, 0);
    let deliveryDateZero = new Date(deliveryDate);
    deliveryDateZero.setUTCHours(0, 0, 0, 0);
    let deliveryDateIsToday = nowZero.getTime() === deliveryDateZero.getTime();

    // console.log('computeDeliveryIntervals', nowZero, deliveryDateZero);
    // console.log('computeDeliveryIntervals', deliveryIntervals, deliveryDate, deliveryDateIsToday);

    let nowHour = now.getHours();

    return deliveryIntervals.map(deliveryInterval => {
        if (deliveryInterval.status !== Status.ACTIVE) {
            return ;
        }
        if (deliveryInterval.isDisabledForToday === true && deliveryDateIsToday) {
            return {
                interval: deliveryInterval.interval,
                isAvailable: false,
            };
        }
        let [start, end] = deliveryInterval.interval.split('-');
        start = parseInt(start, 10);
        end = parseInt(end, 10);
        let isAvailable = deliveryDateIsToday === true ? start >= nowHour ? true : start <= nowHour && nowHour < end : true;
        return {
            interval: deliveryInterval.interval,
            isAvailable: isAvailable,
        };
    }).filter(Boolean);
}

CalendarHelper.prototype.dateIsInWeekend = function (date) {
    let dayInWeek = date.getUTCDay();
    return dayInWeek === 6 || dayInWeek === 0;
}

CalendarHelper.prototype.dateIsInFreeDays = function (date) {
    let weekday = date.getUTCDay();
    //console.log(weekday + " = " + date);

    let time = date.getTime();

    if (this.freeDays.indexOf(time) !== -1) {
        return true;
    }

    if (weekday === 6 && this.deliveryOptions.workingSaturday === false) {
        return true;
    }
    if (weekday === 0 && this.deliveryOptions.workingSunday === false) {
        return true;
    }

    return false;
}

CalendarHelper.prototype.dateStringToDate = function (string) {
    let date = new Date(string);
    if (this.dateIsValid(date)) {
        return date;
    }
    let splitted = string.split(' ');
    let s = splitted[0].split('-');
    date = new Date();
    date.setUTCHours(0, 0, 0, 0);
    date.setUTCFullYear(Number(s[0]), Number(s[1])-1, Number(s[2]));
    if (this.dateIsValid(date)) {
        return date;
    }
    return false;
}

CalendarHelper.prototype.dateToString = function (date) {
    let day = ('0' + date.getUTCDate()).slice(-2) ;
    let month = ('0' + (date.getUTCMonth()+1)).slice(-2);
    let year = date.getUTCFullYear();
    return year + '-' +  month + '-' + day;
}

CalendarHelper.prototype.dateIsValid = function (date) {
    if (Object.prototype.toString.call(date) === "[object Date]") {
        // it is a date
        if (isNaN(date.getTime())) {  // date.valueOf() could also work
            // date is not valid
            return false;
        }
        else {
            // date is valid
            return true;
        }
    }
    else {
        // not a date
        return false;
    }
}

const CalendarHelperSingleton = new CalendarHelper();
// Object.freeze(CalendarHelperSingleton);
global.CalendarHelperSingleton = CalendarHelperSingleton;

module.exports = CalendarHelper;